export default "__VITE_ASSET__fPe6UIzY__"